import Reflux from 'reflux';

const DeflectorActions = Reflux.createActions({
  cycle: { asyncResult: true },
  list: { asyncResult: true },
});

export default DeflectorActions;



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/graylog-project-cli-release/workspace/.repos/graylog2-server/graylog2-web-interface/src/actions/indices/DeflectorActions.jsx